import React from "react";
import { useTranslation } from "react-i18next";

const ITEMS = [
  { key: "tv5", href: "https://www.youtube.com/watch?v=KA7K8J2h48Q" },
  {
    key: "africa",
    href: "https://africa.com/how-an-ai-app-is-helping-burundian-farmers-spot-crop-diseases-early/",
  },
  {
    key: "andika",
    href: "https://andikamagazine.net/elie-bubuyas-hyphen-tech-is-transforming-agriculture-and-business-in-burundi-through-ai/",
  },
  {
    key: "agora",
    href: "https://www.agorainternational.it/articles/burundi-mastering-the-worlds-assistant/",
  },
  { key: "paris", href: "https://parispeaceforum.org/ai-action-summit-about/" },
  {
    key: "award",
    href: "https://andikamagazine.net/elie-bubuyas-hyphen-tech-is-transforming-agriculture-and-business-in-burundi-through-ai/",
  },
];

/**
 * Press rail. Set in the display serif rather than as grey sans logos-that-
 * aren't-logos — the publication names carry more authority as mastheads.
 */
export default function AsFeaturedIn() {
  const { t } = useTranslation();

  return (
    <section className="border-b border-agri-rule bg-agri-card">
      <div className="container-x py-10 sm:py-12">
        <div className="grid grid-cols-1 items-center gap-6 lg:grid-cols-12 lg:gap-10">
          <p className="kicker-rule lg:col-span-3">{t("design.press.badge")}</p>

          <ul className="flex flex-wrap items-baseline gap-x-7 gap-y-3 lg:col-span-9 lg:justify-end">
            {ITEMS.map((item) => (
              <li key={item.key}>
                <a
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-display text-[0.9375rem] font-medium tracking-[-0.01em] text-agri-ink60 decoration-agri-clay/40 underline-offset-4 transition-colors duration-200 hover:text-agri-ink hover:underline sm:text-base"
                >
                  {t(`design.press.items.${item.key}`)}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
